// purpose: 次の Gate キューまでの残り tick を導出する共有純関数（HUD 予告と R2 ゲート演出が同じ値を読む）
import { StageCueKind } from '../data/stages';
import type { StageDirector } from './StageDirector';

/** Gate/HUD の接近演出を実時間で維持する保護区間。 */
export const GATE_APPROACH_TICKS = 300;

/**
 * Ticks until the stage's next Gate cue, -1 when none is promised. A boss cue
 * in between halts stageTick (bossGate returns early in StageDirector.update),
 * so a gate beyond one is not promised — the countdown would stall mid-fight.
 * Allocation-free: called per publish/frame.
 */
export function nextGateTicks(director: StageDirector): number {
  const cues = director.spec.cues;
  for (let i = director.cueIndex; i < cues.length; i += 1) {
    const cue = cues[i];
    if (!cue) return -1;
    if (cue.kind === StageCueKind.MidBoss || cue.kind === StageCueKind.FinalBoss) return -1;
    if (cue.kind === StageCueKind.Gate) return Math.max(0, director.scaledTick(cue.tick) - director.stageTick);
  }
  return -1;
}
